export default "__VITE_ASSET__8521ef0e__"